import { render, staticRenderFns } from "./MessageSummaryReport.vue?vue&type=template&id=7137beaf&scoped=true&"
import script from "./MessageSummaryReport.vue?vue&type=script&lang=ts&"
export * from "./MessageSummaryReport.vue?vue&type=script&lang=ts&"
import style0 from "./MessageSummaryReport.vue?vue&type=style&index=0&id=7137beaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7137beaf",
  null
  
)

export default component.exports